import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { FieldValueWidgetComponent } from './field-value-widget/field-value-widget.component';
import { HtmlWidgetComponent } from './html-widget/html-widget.component';
import { LabelWidgetComponent } from './label-widget/label-widget.component';
import { PhoenixPipesModule } from 'app/pipes/pipes';
import { HtmlWidgetSettingsComponent } from './html-widget/html-widget-settings/html-widget-settings.component';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatOptionModule } from '@angular/material/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LineWidgetComponent } from './line-widget/line-widget.component';
import { FuseWidgetModule } from '@fuse/components';
import { HtmlEditorModule } from 'app/components/html-editor/html-editor.module';

@NgModule({
    imports: [
        CommonModule,
        MatMenuModule,
        MatIconModule,
        MatDialogModule,
        MatToolbarModule,
        MatInputModule,
        MatFormFieldModule,
        MatOptionModule,
        MatSelectModule,
        MatCheckboxModule,
        MatButtonModule,
        MatTooltipModule,
        FuseWidgetModule,
        FuseSharedModule,
        PhoenixPipesModule.forRoot(),
        HtmlEditorModule

    ],
    declarations: [
        FieldValueWidgetComponent,
        LabelWidgetComponent,
        HtmlWidgetComponent,
        HtmlWidgetSettingsComponent,
        LineWidgetComponent,
    ],
    exports: [
        FieldValueWidgetComponent,
        LabelWidgetComponent,
        HtmlWidgetComponent,
        HtmlWidgetSettingsComponent,
        LineWidgetComponent,
    ]
})
export class LabelWidgetsModule { }
